import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import { AngularFirestore } from "angularfire2/firestore";
import { Headers, RequestOptions, Http } from "@angular/http";
import { AppConfig } from '../config';
import { map } from 'rxjs/operators';
import { ENV } from '@app/env'
import * as moment from 'moment';

@Injectable()
export class PatientProvider {

  constructor(
    private afs: AngularFirestore,
    private http: Http
  ) {}

  /************* Patient DB Functions ********************************/
  listPatients(program_id)  {
    return this.afs.collection<any>(`program/${program_id}/patients`, ref =>
      ref.orderBy("last_name", "asc")
    );
  }

  getPatient(program_id: string, patient_id: string) {
    return this.afs.collection<any>(`program/${program_id}/patients`).doc(patient_id);
  }

  addPatient(program_id: string, patient: any, user: any, document?: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    patient = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...patient };

    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/patients`).doc(doc_id).ref, patient);
      if(document)  {
        document.url = document.enrolment_doc_url;
        if(document.enrolmentment_doc_id) {
          document.id = document.enrolmentment_doc_id
        } else {
          document.id = this.afs.createId();
        }
        delete document.patient;
        delete document.enrolmentment_doc_id;
        delete document.enrolment_url;
        delete document.enrolment_doc_url;
        delete document.enrolmentURL;
        delete document.b64;
        delete document.updatedAt;
        delete document.updatedBy;
        const docpatient = {
          id: patient.id,
          first_name: patient.first_name,
          last_name: patient.last_name,
          program_patient_id: patient.program_patient_id
        }
        const newdocument = { completed: true, type: 'Enrolment', notes: 'New enrolment form from patient add - edit form', ext: 'pdf', id: document.id, createdAt, createdBy, updatedAt, updatedBy, ...docpatient, ...document };
        console.log('Doc to Submit: ', newdocument)
        batch.set(this.afs.collection<any>(`program/${program_id}/docsfiles`).doc(document.id).ref, newdocument);
        batch.set(this.afs.collection<any>(`program/${program_id}/patients/${doc_id}/docsfiles`).doc(document.id).ref, newdocument);
      }
      return batch.commit();
  }

  updatePatient(program_id: string, patient_id, patient: any, user: any, document?: any)  {
    const updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    const updatedBy = user;
    patient = { updatedAt, updatedBy, ...patient };
    var batch = this.afs.firestore.batch();
    if(document)  {
      document.url = document.enrolment_doc_url;
      if(document.enrolmentment_doc_id) {
        document.id = document.enrolmentment_doc_id
      } else {
        document.id = this.afs.createId();
      }
      delete document.patient;
      delete document.enrolmentment_doc_id;
      delete document.enrolment_url;
      delete document.enrolment_doc_url;
      delete document.enrolmentURL;
      delete document.b64;
      delete document.updatedAt;
      delete document.updatedBy;
      const docpatient = {
        id: patient.id,
        first_name: patient.first_name,
        last_name: patient.last_name,
        program_patient_id: patient.program_patient_id
      }
      const newdocument = { completed: true, type: 'Enrolment', notes: 'New enrolment form from patient add - edit form', ext: 'pdf', id: document.id, createdAt: updatedAt, createdBy: updatedBy, updatedAt, updatedBy, ...docpatient, ...document };
      console.log('Doc to Submit: ', newdocument)
      batch.set(this.afs.collection<any>(`program/${program_id}/docsfiles`).doc(document.id).ref, newdocument);
      batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/docsfiles`).doc(document.id).ref, newdocument);
    }
    batch.update(this.afs.collection<any>(`program/${program_id}/patients`).doc(patient_id).ref, patient);
    return batch.commit();
  }

  deletePatient(program_id: string, patient_id: string)  {
    var batch = this.afs.firestore.batch();
    const docRef = this.afs.doc(`program/${program_id}/patients/${patient_id}`).ref;
    batch.delete(docRef);
    return batch.commit();
  }

  listDoctorsByClinic(program_id, institution_id)  {
    return this.afs.collection<any>(`program/${program_id}/doctors`, ref =>
      ref
      .where('program_institution_id', '==', institution_id)
      .orderBy("last_name", "asc")
    );
  }

  /************* Patient Chart DB Functions ********************************/
  listCharts(program_id, patient_id)  {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/chart_history`, ref =>
      ref.orderBy("date", "asc")
    );
  }

  addChart(program_id: string, patient_id: string, chart: any, user: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    chart = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...chart };
    const patient_latest_chart = {
      chart_id: doc_id,
      chart_notes: chart.notes,
      chart_type: chart.type,
      chart_createdAt: createdAt,
      chart_createdBy: user.name,
      chart_createdById: user.id
    }
    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/charts`).doc(doc_id).ref, chart);
    batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/chart_history`).doc(doc_id).ref, chart);
    batch.update(this.afs.collection<any>(`program/${program_id}/patients`).doc(patient_id).ref, patient_latest_chart);
    return batch.commit();
  }

  /************* Patient Adherence DB Functions ********************************/
  listAdherenceCalls(program_id, patient_id)  {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/adherencecall_history`, ref =>
      ref.orderBy("createdAt", "asc")
    );
  }

  addAdherenceCall(program_id: string, patient_id: string, adherence: any, user: any) {
    const doc_id = this.afs.createId();
    const bp_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    adherence = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...adherence };
    const patient_latest_adherence = {
      adherence_id: doc_id,
      adherence_callnumber: adherence.callnumber,
      adherence_date: adherence.date,
      adherence_outcome: adherence.outcome, 
      adherence_dose: adherence.dose,
      adherence_bp_systolic: adherence.bp_systolic,
      adherence_bp_diastolic: adherence.bp_diastolic,
      adherence_notes: adherence.notes,
      adherence_createdAt: createdAt,
      adherence_createdBy: user.name,
      adherence_createdById: user.id,
      bp_origin: 'Adherence Call',
      bp_systolic: adherence.bp_systolic,
      bp_diastolic: adherence.bp_diastolic,
      bp_date: adherence.date,
      bp_id: bp_id
    }
  
    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/adherencecalls`).doc(doc_id).ref, adherence);
    batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/adherencecall_history`).doc(doc_id).ref, adherence);
    batch.update(this.afs.collection<any>(`program/${program_id}/patients`).doc(patient_id).ref, patient_latest_adherence);
    if (adherence.bp_systolic && adherence.bp_diastolic) {
      const bp = {
        origin: 'Adherence Call',
        systolic: adherence.bp_systolic,
        diastolic: adherence.bp_diastolic,
        date: adherence.date,
        createdAt: createdAt,
        createdBy: user.name,
        createdById: user.id
      }
      batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/bloodpressure_history`).doc(bp_id).ref, bp);
    }
    return batch.commit();
  }

  /************* Patient Update Status *******************************/
  listStatuses(program_id, patient_id)  {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/status_history`, ref =>
      ref.orderBy("createdAt", "desc")
    );
  }

  updateTherapy(program_id: string, patient_id: string, therapy: any, user: any) {
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    let patient_latest = {
      therapy_status: therapy.therapy_status,
      therapy_substatus: therapy.therapy_substatus ? therapy.therapy_substatus : null,
      therapy_type: therapy.therapy_type ? therapy.therapy_type : null,
      therapy_createdAt: createdAt,
      therapy_createdBy: user.name,
      therapy_createdById: user.id,
    }

    var batch = this.afs.firestore.batch();
    batch.update(this.afs.collection<any>(`program/${program_id}/patients`).doc(patient_id).ref, patient_latest);
    return batch.commit()
  }

  updateStatus(program_id: string, patient_id: string, current_status: any, status: any, user: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;

    status = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...status };
    let patient_latest = {
      status_id: doc_id,
      status: status.status,
      substatus: status.substatus ? status.substatus : null,
      status_notes: status.notes,
      status_date: status.date,
      status_createdAt: status.date,
      status_createdBy: user.name,
      status_createdById: user.id,
    }

    const newStatus = status.status.replace(/ /g, '_');
    if (current_status !== newStatus) {
      patient_latest[newStatus] = status.date;
      patient_latest[newStatus + '_createdBy'] = user.name;
      patient_latest[newStatus + '_createdById'] = user.id;
      patient_latest[newStatus + '_createdAt'] = createdAt;
    }

    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/statuses`).doc(doc_id).ref, status);
    batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/status_history`).doc(doc_id).ref, status);
    batch.update(this.afs.collection<any>(`program/${program_id}/patients`).doc(patient_id).ref, patient_latest);
    return batch.commit()
 }

  /************* Patient AE DB Functions ********************************/
  listAdverseEvents(program_id, patient_id)  {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/adverseevent_history`, ref =>
      ref.orderBy("createdAt", "desc")
    );
  }

  addAdverseEvent(program_id: string, patient_id: string, adverseevent: any, user: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    adverseevent = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...adverseevent };
  
    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/adverseevents`).doc(doc_id).ref, adverseevent);
    batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/adverseevent_history`).doc(doc_id).ref, adverseevent);
    return batch.commit();
  }

  /************* Patient Clinical DB Functions ********************************/
  listClinical(program_id, patient_id)  {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/clinical_history`, ref =>
      ref.orderBy("createdAt", "asc")
    );
  }

  addClinical(program_id: string, patient_id: string, clinical: any, user: any) {
    const doc_id = this.afs.createId();
    const bp_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    clinical = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...clinical };
    const patient_latest_clinical = {
      clinical_id: doc_id,
      clinical_date: clinical.date,
      clinical_allergies: clinical.allergies,
      clinical_current_medications: clinical.current_medications,
      clinical_previous_medications: clinical.previous_medications,
      clinical_notes: clinical.notes,
      clinical_bp_systolic: clinical.bp_systolic,
      clinical_bp_diastolic: clinical.bp_diastolic,
      clinical_height: clinical.height,
      clinical_weight: clinical.weight,
      clinical_createdAt: createdAt,
      clinical_createdBy: user.name,
      clinical_createdById: user.id,
      bp_origin: 'Clinical',
      bp_systolic: clinical.bp_systolic,
      bp_diastolic: clinical.bp_diastolic,
      bp_date: clinical.date,
      bp_id: bp_id,
    }
    if (clinical.height) {
      patient_latest_clinical['height'] = clinical.height;
      patient_latest_clinical['height_date'] = clinical.date;
      patient_latest_clinical['height_origin'] = 'Clinical'
    }
    if (clinical.weight) {
      patient_latest_clinical['weight'] = clinical.weight;
      patient_latest_clinical['weight_date'] = clinical.date;
      patient_latest_clinical['weight_origin'] = 'Clinical'
    }
  
    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/clinical`).doc(doc_id).ref, clinical);
    batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/clinical_history`).doc(doc_id).ref, clinical);
    batch.update(this.afs.collection<any>(`program/${program_id}/patients`).doc(patient_id).ref, patient_latest_clinical);
    if (clinical.bp_systolic && clinical.bp_diastolic) {
      const bp = {
        origin: 'Clinical',
        systolic: clinical.bp_systolic,
        diastolic: clinical.bp_diastolic,
        date: clinical.date,
        createdAt: createdAt,
        createdBy: user.name,
        createdById: user.id
      }
      batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/bloodpressure_history`).doc(bp_id).ref, bp);
    }
    return batch.commit();
  }

  /************* Patient Documents DB Functions ********************************/
  listDocuments(program_id, patient_id)  {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/docsfiles`, ref =>
      ref
        .orderBy("createdAt", "desc")
    );
  }

  listDocumentsIncomplete(program_id, patient_id)  {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/docsfiles`, ref =>
      ref
        .where("completed", "==", false)
        .orderBy("createdAt", "asc")
    );
  }

  listDocumentsComplete(program_id, patient_id)  {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/docsfiles`, ref =>
      ref
        .where("completed", "==", true)
        .orderBy("createdAt", "asc")
    );
  }

  addDocument(program_id, patient: any, document: any, user: any, type?: string, description?: string) {
    const doc_id = this.afs.createId();
    const bp_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    delete document['b64'];
    document = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...patient, ...document };
    if (type) document.type = type;
    if (description) document.notes = description;

    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/docsfiles`).doc(doc_id).ref, document);
    batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient.id}/docsfiles`).doc(doc_id).ref, document);
    return batch.commit();
  }

  transferDocument(program_id: string, patient: any, document: any, user: any) {
    console.log('Transfer Doc ID: ', document.id)
    const createdAt = document.createdAt
    const createdBy = { id: null, name: 'Fax Service'}
    const updatedAt = this.timestamp;
    const updatedBy = user;
    delete document['b64'];
    delete document['updatedAt']
    delete document['updatedBy']
    document = { id: document.id, createdAt, createdBy, updatedAt, updatedBy, ...patient, ...document };

    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/docsfiles`).doc(document.id).ref, document);
    batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient.id}/docsfiles`).doc(document.id).ref, document);
    batch.update(this.afs.collection<any>(`program/${program_id}/docsfiles`).doc(document.id).ref, { completed: true });
    return batch.commit();
  }

  classifyDocument(program_id: string, patient_id: string, document: any, user: any) {
    console.log('Classify Doc: ', document.id)
    const updatedAt = this.timestamp;
    const updatedBy = user;
    document = { id: document.id, updatedAt, updatedBy, ...document };

    var batch = this.afs.firestore.batch();
    batch.update(this.afs.collection<any>(`program/${program_id}/docsfiles`).doc(document.id).ref, document);
    batch.update(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/docsfiles`).doc(document.id).ref, document);
    return batch.commit();
  }

  deleteDocument(program_id:string, patient_id: string, document_id: string) {
    var batch = this.afs.firestore.batch();
    batch.delete(this.afs.collection<any>(`program/${program_id}/docsfiles`).doc(document_id).ref);
    batch.delete(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/docsfiles`).doc(document_id).ref);
    return batch.commit();
  } 

  /************* Patient Dispensing DB Functions ********************************/
  listDispensing(program_id, patient_id)  {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/dispensing_history`, ref =>
      ref.orderBy("createdAt", "asc")
    );
  }

  addDispensing(program_id: string, patient: any, dispensing: any, user: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    dispensing = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...dispensing };
    const patient_latest = {
      dispensing_id: doc_id,
      dispensing_pharmacy: dispensing.pharmacy.name,
      dispensing_pharmacy_id: dispensing.pharmacy.id,
      dispensing_therapy: dispensing.therapy,
      dispensing_indication: dispensing.indication,
      dispensing_dose: dispensing.dose,
      dispensing_quantity: dispensing.quantity,
      dispensing_fill_date: dispensing.fill_date,
      dispensing_notes: dispensing.notes,
      dispensing_createdAt: createdAt,
      dispensing_createdBy: user.name,
      dispensing_createdById: user.id,
    }

    if (!patient.dispensing_first_fill_date) {
      patient_latest['dispensing_first_fill_date'] = createdAt;
      patient_latest['dispensing_first_fill_date_createdBy'] = user.name;
      patient_latest['dispensing_first_fill_date_createdById'] = user.id;
    }
    
    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/dispensing`).doc(doc_id).ref, dispensing);
    batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient.id}/dispensing_history`).doc(doc_id).ref, dispensing);
    batch.update(this.afs.collection<any>(`program/${program_id}/patients`).doc(patient.id).ref, patient_latest);
    return batch.commit();
  }

  updateDispensing(program_id: string, patient: any, dispensing: any, user: any) {
    const updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    const updatedBy = user;
    dispensing = { updatedAt, updatedBy, ...dispensing };
    
    var batch = this.afs.firestore.batch();
    batch.update(this.afs.collection<any>(`program/${program_id}/dispensing`).doc(dispensing.id).ref, dispensing);
    batch.update(this.afs.collection<any>(`program/${program_id}/patients/${patient.id}/dispensing_history`).doc(dispensing.id).ref, dispensing);
    return batch.commit();
  }

  deleteDispening(program_id: string, patient_id: string, dispensing_id: string)  {
    var batch = this.afs.firestore.batch();
    batch.delete(this.afs.collection<any>(`program/${program_id}/dispensing`).doc(dispensing_id).ref);
    batch.delete(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/dispensing_history`).doc(dispensing_id).ref);
    return batch.commit();
  }

  /************* Patient Order DB Functions ********************************/
  listOrders(program_id, patient_id)  {
    return this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/order_history`, ref =>
      ref.orderBy("createdAt", "asc")
    );
  }

  addOrder(program_id: string, patient_id: string, order: any, patient: any, user: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    order = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...order };
    let patient_latest = {
      order_generated_id: order.order_number,
      order_id: doc_id,
      order_type: order.type,
      order_commercial_compassionate: order.commercial_compassionate,
      order_doctor: order.doctor,
      order_dose: order.dose ? order.dose : null,
      order_repeats: order.repeats ? order.repeats : null,
      order_quantity: order.quantity ? order.quantity : null,
      order_pharmacy: order.pharmacy ? order.pharmacy : null,
      order_fax_number: order.fax_number ? order.fax_number : null,
      order_notes: order.notes,
      order_createdAt: createdAt,
      order_createdBy: user.name,
      order_createdById: user.id,
    }
    if (!patient.welcome_package_ordered) {
      patient_latest['welcome_package_ordered'] = createdAt,
      patient_latest['welcome_package_ordered_createdBy'] = user.name,
      patient_latest['welcome_package_ordered_createdById'] = user.id,
      patient_latest['welcome_package_ordered_createdAt'] = createdAt
    }
    if (!patient.order_first_date) {
      patient_latest['order_first_date'] = createdAt;
      patient_latest['order_first_date_createdBy'] = user.name,
      patient_latest['order_first_date_createdById'] = user.id,
      patient_latest['order_first_date_createdAt'] = createdAt
    }
    console.log('Order: ', order);
    console.log('Patient: ', patient_latest)
    
    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/orders`).doc(doc_id).ref, order);
    batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/order_history`).doc(doc_id).ref, order);
    batch.update(this.afs.collection<any>(`program/${program_id}/patients`).doc(patient_id).ref, patient_latest);
    return batch.commit();
  }

  /************* Patient Utility Functions ********************************/
  addReimbursement(program_id: string, patient_id: string, reimbursement_type: string, reimbursement: any, user: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    reimbursement = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...reimbursement };
    let patient_latest = {};
    patient_latest[reimbursement_type + '_id'] = doc_id;
    patient_latest[reimbursement_type + '_createdBy'] = user;
    patient_latest[reimbursement_type + '_createdAt'] = createdAt;
    patient_latest[reimbursement_type] = reimbursement;
    
    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/reimbursements`).doc(doc_id).ref, reimbursement);
    batch.set(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/reimbursement_history`).doc(doc_id).ref, reimbursement);
    batch.update(this.afs.collection<any>(`program/${program_id}/patients`).doc(patient_id).ref, patient_latest);
    return batch.commit();
  }

  updateReimbursement(program_id: string, patient_id: string, reimbursement_type: string, reimbursement: any, user: any) {
    const updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    const updatedBy = user;
    reimbursement = { updatedAt, updatedBy, ...reimbursement };
    let patient_latest = {};
    patient_latest[reimbursement_type + '_id'] = reimbursement.id;
    patient_latest[reimbursement_type + '_udpatedBy'] = user;
    patient_latest[reimbursement_type + '_updatedAt'] = updatedAt;
    patient_latest[reimbursement_type] = reimbursement;
    
    var batch = this.afs.firestore.batch();
    batch.update(this.afs.collection<any>(`program/${program_id}/reimbursements`).doc(reimbursement.id).ref, reimbursement);
    batch.update(this.afs.collection<any>(`program/${program_id}/patients/${patient_id}/reimbursement_history`).doc(reimbursement.id).ref, reimbursement);
    batch.update(this.afs.collection<any>(`program/${program_id}/patients`).doc(patient_id).ref, patient_latest);
    return batch.commit();
  }
  
  /************* Patient Utility Functions ********************************/
  get timestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  }

  async getNextPatientId(program_id: string, therapy: string) {
    return new Promise((resolve, reject) => {
      const increment = firebase.firestore.FieldValue.increment(1);
      const program = this.afs.doc(`program/${program_id}/therapy/${therapy}`);
      program.update({ patientindex: increment }).then(t => {
        program.ref.get().then(function(doc) {
          if (doc.exists) {
            const dbtherapy = doc.data()
            const patientId = dbtherapy.prefix + dbtherapy.patientindex + '-' +  moment(Date.now()).format('MMYY').toString();
            resolve(patientId);
          } else {
            reject(null);
          }
        })
        .catch(err => {
          reject(err);
        })
      })
      .catch(err => {
        reject(err);
      })
    });
  }

  getUCINumber(patient) {
    var headers = new Headers()
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    let options = new RequestOptions({ headers: headers });
    let body = `secret=${ENV.API_SECRET}&first_name=${patient.first_name}&last_name=${patient.last_name}&address=${patient.address}&city=${patient.city}&province=${patient.province}&postal_code=${patient.postal_code}&dob=${patient.dob}&language=${patient.language}&gender=${patient.gender}&coveragetype=${patient.coveragetype}`;
    console.log('Body: ', body);
    return new Promise((resolve, reject) => {
       this.http.post(`${ENV.FIREBASE_API_URL}/getUCI`, body, options)
          .pipe(
            map(res => res.json()) // or any other operator
          )
          .subscribe(
          (data) => {
              // console.log('information from the api call',data);
              // this.local.set('agendaData', data);

              //this.data = data;
              resolve(data);
          },
          (err) => {
              reject('Error: ' + err)
          })
  });
  }

}



// WEBPACK FOOTER //
// ./src/providers/patient/patient.ts